import React from 'react';
import './Toggle.scss';

type ToggleState = 'left' | 'right';
type ToggleMode = 'desktop' | 'mobile';
type ToggleSize = 'normal' | 'compact';

interface IToggleProps {
    leftLabel: string;
    rightLabel: string;
    onToggle: () => void;
    toggleState: ToggleState;
    mode?: ToggleMode;
    size?: ToggleSize;
}

const Toggle = ({ leftLabel, rightLabel, onToggle, toggleState, mode = 'desktop', size = 'normal' }: IToggleProps) => (
    <button
        type='button'
        className={`Toggle Toggle--${mode} Toggle--${size}`}
        onClick={onToggle}
    >
        <div className='Toggle__wrapper'>
            <div className={`Toggle__slider Toggle__slider--${toggleState}`} />
            <div className={`Toggle__option ${toggleState === 'left' ? 'is-active' : ''}`}>
                {leftLabel}
            </div>
            <div className={`Toggle__option ${toggleState === 'right' ? 'is-active' : ''}`}>
                {rightLabel}
            </div>
        </div>
    </button>
);

export default Toggle;
